import {getYearMonthDayBySeverTime} from "@/utils/time";
import {getFileUrl} from "@/api/file";



export function formatBannerDataFromSever(severData) {
    // console.log('ss',severData);
    const {img:sample} = severData;//timeSeg, validateS, validateE, 
    console.log('img',{sample})
    return {
        ...severData,
          sample: getSampleArrayFromSever({sample}),
    };
}

export function formatDataToSever(form) {
    // console.log('aaa',form);
    const { sample} = form;//, playDate, timeSeg, except
    // console.log('b:',sample);
    // console.log('bb',getSampleStrToSever({sample}))
    return {
        ...form, 
        img: getSampleStrToSever({sample}),
    }
}

export function getSampleStrToSever({sample}) {
    // console.log('bbb:',sample);
    // console.log('bb:',sample?.map(item => item.name).join(';') ?? '');
    return sample?.map(item => item.name).join(';') ?? '';
}

export function getSampleArrayFromSever({sample}) {
    console.log('getSampleArrayFromSever',sample);
    return sample?.split(';').filter(item=>!!item).map(fileName => {
        return {name: fileName, url: getFileUrl({name: fileName})};
    }) ?? []
}


export class XMLManager {
    #xmlDocument;

    constructor(xmlStr) {
        this.#parseXMLString({xmlStr});
    }

    #parseXMLString({xmlStr}) {
        const domParser = new DOMParser();
        this.#xmlDocument = domParser.parseFromString(xmlStr, 'text/xml');
        return this.#xmlDocument;
    }

    getXMLElementsByTagName({tagName}) {
        return this.#xmlDocument.getElementsByTagName(tagName);
    }

    getXMLNodeValueByAttributeName({tagName}) {
        return [...this.getXMLElementsByTagName({tagName})].map(element => {
            const obj = {};
            element.getAttributeNames().forEach(attributeName => {
                obj[attributeName] = element.getAttribute(attributeName);
            });
            return obj;
        });
    }
}